import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import { useLibraryCreativesContext } from "../../../../core/components/creatives/library/useLibraryCreativesContext";
import "./../library/creativestyle.css";
import AdGroupHeroCard from "../components/AdGroupHeroCard";
import AdGroupMediaCard from "../components/AdGroupMediaCard";
import PageHeaderLayoutComponent from "../components/HeaderGroup";

const AdGroupDetail = () => {
  const {
    adgroupinfo,
    refetchAdGroupInfo,
    orgMedias,
  } = useLibraryCreativesContext();
  const [mediaKeys, setMediaKeys] = useState([]);

  useEffect(() => {
    if (
      adgroupinfo &&
      adgroupinfo.adGroupCreatives &&
      adgroupinfo.adGroupCreatives.medias
    ) {
      const keys = adgroupinfo.adGroupCreatives.medias.map(media => media.key);
      setMediaKeys(keys);
    }
  }, [adgroupinfo]);

  return (
    <>
      <PageHeaderLayoutComponent
        adgroupinfo={adgroupinfo}
        mediaType="DISPLAY"
      />
      <Row gutter={[16, 16]} className="crow-whole-page">
        <Col span={24}>
          <AdGroupHeroCard
            adgroupinfo={adgroupinfo}
            mediaType="DISPLAY"
            mediaKeys={mediaKeys}
          />
        </Col>
        <Col span={24} className="ccol-ad-groups">
          <AdGroupMediaCard
            mediaType="DISPLAY"
            adgroupinfo={adgroupinfo}
            refetchAdGroupInfo={refetchAdGroupInfo}
            orgMedias={orgMedias}
            adGroupId={
              adgroupinfo && adgroupinfo.adGroupCreatives
                ? adgroupinfo.adGroupCreatives.id
                : ""
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default AdGroupDetail;